import { render } from "./VendorJuridicalPersonForm.vue?vue&type=template&id=0f6fbbdd&scoped=true"
import script from "./VendorJuridicalPersonForm.vue?vue&type=script&lang=js"
export * from "./VendorJuridicalPersonForm.vue?vue&type=script&lang=js"

import "./VendorJuridicalPersonForm.vue?vue&type=style&index=0&id=0f6fbbdd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6fbbdd"]])

export default __exports__